import React, { memo } from 'react';
import { ProfilePicture } from '@/components/domain/common/ProfilePicture';
import { CardWrapper } from '@/components/domain/posts/CardWrapper';
import { Card } from '@/components/gluestack/card';
import { HStack } from '@/components/gluestack/hstack';
import { Pressable } from '@/components/gluestack/pressable';
import { Text } from '@/components/gluestack/text';
import type { Member } from '@/models/Member';

interface IFeedComposerPromptProps {
  member: Member;
  placeholder: string;
  accessibilityLabel: string;
  onPress: () => void;
}

export const FeedComposerPrompt = memo(function FeedComposerPrompt({
  member,
  placeholder,
  accessibilityLabel,
  onPress,
}: IFeedComposerPromptProps) {
  return (
    <CardWrapper>
      <Card size="md" className="p-3">
        <HStack className="items-center gap-3">
          <ProfilePicture member={member} size="sm" showPresence={false} />
          <Pressable
            accessibilityRole="button"
            accessibilityLabel={accessibilityLabel}
            onPress={onPress}
            className="min-h-11 flex-1 justify-center rounded-full bg-background-100/75 px-4 active:bg-background-100 web:cursor-pointer web:hover:bg-background-100">
            <Text className="text-typography-500">{placeholder}</Text>
          </Pressable>
        </HStack>
      </Card>
    </CardWrapper>
  );
});
